import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllDesignerDiscountBanners } from "../../State/DesignerDiscountBanner/Action";

export default function DesignerDiscountBanners() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const publicDesignerDiscountBanner = useSelector((state) => state.publicDesignerDiscountBanner);

    useEffect(() => {
        dispatch(getAllDesignerDiscountBanners());
    }, [dispatch]);

    return (
        <section className="py-6 px-2 bg-white">
            <div className="max-w-7xl mx-auto px-[0.25%]">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 uppercase mb-4">
                    ALL DESIGNERS ON DISCOUNT
                </h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 pb-4">
                    {publicDesignerDiscountBanner?.designerDiscountBanners?.response
                        ?.filter((banner) => {
                            const today = new Date();
                            const start = new Date(banner.startDate);
                            const end = new Date(banner.endDate);

                            return today >= start && today <= end; // ✅ valid date range
                        })
                        .map((banner) => (
                            <div
                                key={banner?.id}
                                className="bg-white rounded-none border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer group"
                                onClick={() =>
                                    navigate(
                                        `/collections/vendor/${banner?.vendor?.name}/discount/${banner?.discountPercentage}`
                                    )
                                }
                            >
                                <div className="relative h-96 overflow-hidden bg-neutral-100">
                                    <img
                                        src={banner.imageUrl}
                                        alt={banner?.vendor?.name}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                    />
                                    {/* <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-all duration-300" /> */}
                                    <div className="absolute bottom-4 left-4 text-white">
                                        <h3 className="text-lg font-bold mb-1">
                                            {banner?.vendor?.name?.toUpperCase()}
                                        </h3>
                                        <p className="text-sm font-medium">
                                            UPTO {banner?.discountPercentage}% OFF
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </section>
    );
}
